import { render, staticRenderFns } from "./goodsMergeEdit.vue?vue&type=template&id=21d5f625&scoped=true&"
import script from "./goodsMergeEdit.vue?vue&type=script&lang=js&"
export * from "./goodsMergeEdit.vue?vue&type=script&lang=js&"
import style0 from "./goodsMergeEdit.vue?vue&type=style&index=0&id=21d5f625&lang=less&scoped=true&"
import style1 from "./goodsMergeEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d5f625",
  null
  
)

component.options.__file = "goodsMergeEdit.vue"
export default component.exports